import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { client, ProcessingFaxPrescriptionsResponse } from '../../api';

/**
 * Hook to fetch all processing prescriptions received via fax.
 * Pagination is handled client-side.
 */
export const useFetchProcessingPrescriptions = (page: number, perPage: number) => {
  const query = useQuery({
    queryKey: ['processingPrescriptions'], // No page/perPage in key since we fetch all data
    queryFn: async () => {
      const response = await client.get<ProcessingFaxPrescriptionsResponse>('/fax-intake/processing-prescriptions');
      return response.data.processing_prescriptions;
    },
  });

  // Client-side pagination of the fetched data
  const paginatedData = useMemo(() => {
    if (!query.data) {
      return { results: [], total: 0 };
    }

    const startIndex = page * perPage;
    const endIndex = startIndex + perPage;
    const paginatedResults = query.data.slice(startIndex, endIndex);

    return {
      results: paginatedResults,
      total: query.data.length,
    };
  }, [query.data, page, perPage]);

  return {
    ...query,
    data: paginatedData,
  };
};
